import clone from 'lodash/clone';
import { BreadcrumbBucket } from './state';
import { BreadcrumbsAction, DEL_BREADCRUMBS, SET_BREADCRUMBS } from './types';
import { BreadcrumbsKey } from '../../../models/Breadcrumbs';

// FIXME: this subkey structure is hard to type properly, a better data structure should be passed here
export function createBreadcrumbItems(items, subItemKey: string) {
    return items.map(item => ({
        key: item.id,
        value: item.name,
        docCount: item.docCount,
        buckets: item[subItemKey].map(subItem => ({
            key: subItem.id,
            value: subItem.name,
            docCount: subItem.docCount
        }))
    }));
}

export function setBreadcrumbs(
    key: BreadcrumbsKey,
    label: string,
    buckets: BreadcrumbBucket[],
    activeBucket: string
): BreadcrumbsAction {
    return {
        type: SET_BREADCRUMBS,
        payload: {
            key,
            label,
            buckets: clone(buckets),
            activeBucket
        }
    };
}

export const deleteBreadcrumbs = (): BreadcrumbsAction => {
    return {
        type: DEL_BREADCRUMBS
    };
};
